// extracted by mini-css-extract-plugin
module.exports = {"social-links__container":"SocialLinks_social-links__container__PLHNK","social-links__link":"SocialLinks_social-links__link__f6mFw"};